import { apiClient } from '@/shared/api';

import type { CartMutation } from '../config/mutations';
import type { CartApiResponse } from '../config/types';

export function mutateCartApi(mutation: CartMutation) {
  return apiClient<CartApiResponse>('cart/mutations', {
    method: 'POST',
    body: JSON.stringify(mutation),
  });
}

export function getCartApi() {
  return apiClient<CartApiResponse>('cart');
}
